<ng-container *ngFor="let btn of buttons">
  <ng-container *xviIfHasPermissions="btn.permissionCodes">
    <li [ngClass]="btn.class" (click)="btnClickHandler(btn.type)" role="menuitem" *ngIf="btn.visible">
      <span>{{ btn.name | translate }}</span>
    </li>
  </ng-container>
</ng-container>
